import request from "root/js/request";

export const getAnalyticsTradeEconomyDynamic = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  category_id__in,
  brand_id__in,
  supplier_article__in,
  barcode__in,
  subject_id__in,
  product_id__in,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/trade_economy_dynamic/",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      supplier_article__in,
      barcode__in,
      subject_id__in,
      product_id__in,
      ...rest,
    },
  });
  return response.data;
};

